import { IGWidget, addClass } from "../GWidget"

export default function Loading(props:IGWidget){
    return <div className={addClass("loading", props)}><span/><span/><span/></div>
}